/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.Product {
  angular.module("meevo.plugins.product", []);
}